import changeCase from 'change-case-object'

export const API_URL =
  process.env.REACT_APP_CONTEXT === 'production'
    ? process.env.REACT_APP_PRODUCTION_API_URL
    : process.env.REACT_APP_STAGING_API_URL

/**
 * Wrapper around `fetch` to call the Crush API. Since the API only implements
 * POST methods, this always calls a POST. It also handles conversion between
 * camelCase and snake_case.
 *
 * @param  {String} path To be called HTTP Path, beginning with a slash
 * @param  {Object} body Data to be sent to the API. JSON will be converted to
 *                       snake_case
 * @param  {Object} opts Indicating if send/accept json or text
 * @return {Promise}     Resolves with JSON Response in camelCase.
 */
export default function apiFetch(
  path,
  body,
  { send = 'json' } = {}
) {
  const headers = new Headers()
  headers.set('Accept', 'application/json')
  send === 'json' && headers.set('Content-Type', 'application/json')

  const request = fetch(`${API_URL}${path}`, {
    method: 'POST',
    body: send === 'json' ? JSON.stringify(changeCase.snakeCase(body)) : body,
    headers
  })

  return request
    .then(res => res.json())
    .then(json => changeCase.camelCase(json))
}



// WEBPACK FOOTER //
// ./src/lib/apiFetch.js